import {getTestProps} from '@benchling/js-test-utils';
import React from 'react';

import {Continuous2DChartParameters} from 'insights/analytics-visualizations/AnalyticsVisualizationTypes';
import CheckboxInput from 'ui-library/inputs/CheckboxInput';

export interface Continuous2DChartConfigEditorProps {
  onUpdateParameters: (update: Partial<Continuous2DChartParameters>) => void;
  parameters: Continuous2DChartParameters;
  isDisabled?: boolean;
}

export default function Continuous2DChartConfigEditor({
  onUpdateParameters,
  parameters,
  isDisabled = false,
}: Continuous2DChartConfigEditorProps): JSX.Element {
  return (
    <div
      className="u-input-spacing-top"
      {...getTestProps({component: 'Continuous2DChartConfigEditor', element: 'root'})}
    >
      <CheckboxInput
        id="yAxisIncludes0"
        label="Y-axis scale includes 0"
        onChange={(e) => {
          onUpdateParameters({yAxisIncludesZero: e.target.checked});
        }}
        checked={parameters.yAxisIncludesZero}
        disabled={isDisabled}
      />
    </div>
  );
}
